import React from "react";

export default function SmallStatCard({
  label,
  value,
  hint,
  accent = "slate",
  valueTone = "strong",
  progressPercent,
}) {
  const accentStyles = {
    slate: "bg-slate-100 border-black/10 text-[#0f172a] dark:bg-[#111520] dark:border-white/[0.08] dark:text-[#eef2ff]",
    green: "bg-emerald-50 border-emerald-200 text-emerald-800 dark:bg-green-500/10 dark:border-green-500/20 dark:text-green-400",
    orange: "bg-amber-50 border-amber-200 text-amber-800 dark:bg-amber-500/10 dark:border-amber-500/20 dark:text-amber-400",
    rose: "bg-rose-50 border-rose-200 text-rose-800 dark:bg-red-500/10 dark:border-red-500/20 dark:text-red-400",
    amber: "bg-amber-50 border-amber-200 text-amber-800 dark:bg-amber-500/10 dark:border-amber-500/20 dark:text-amber-400",
    blue: "bg-sky-50 border-sky-200 text-sky-800 dark:bg-blue-500/10 dark:border-blue-500/20 dark:text-[#7aaeff]",
  };

  const labelClass =
    valueTone === "muted"
      ? "text-[10px] text-[#64748b] dark:text-[#6b7a9a]"
      : "text-[10px] text-[#64748b] dark:text-[#6b7a9a]";
  const valueClass =
    valueTone === "muted"
      ? "text-xl font-semibold text-[#334155] dark:text-[#6b7a9a] mt-2"
      : "text-2xl font-bold mt-2 text-[#0f172a] dark:text-[#eef2ff]";
  const hintClass =
    valueTone === "muted"
      ? "text-[11px] text-[#64748b] dark:text-[#6b7a9a] mt-2 leading-relaxed"
      : "text-xs text-[#64748b] dark:text-[#6b7a9a] mt-2";

  const pctRaw = progressPercent != null ? Number(progressPercent) : NaN;
  const showProgress = Number.isFinite(pctRaw);
  const pctClamped = showProgress ? Math.min(100, Math.max(0, pctRaw)) : 0;

  return (
    <div
      className={`rounded-2xl border p-4 ${
        accentStyles[accent] || accentStyles.slate
      }`}
    >
      <p className={labelClass}>{label}</p>
      <p className={valueClass}>{value}</p>
      {showProgress ? (
        <div
          className="mt-2 h-1.5 w-full rounded-full bg-white/[0.06] overflow-hidden"
          aria-hidden
        >
          <div
            className={`h-full rounded-full ${
              accent === "amber" ? "bg-amber-500" : "bg-[#7aaeff]/70"
            }`}
            style={{ width: `${pctClamped}%` }}
          />
        </div>
      ) : null}
      {hint ? <p className={hintClass}>{hint}</p> : null}
    </div>
  );
}
